import { ClassData } from '@models/class-data';
import { EventCtaButton } from '@models/events/event-cta-button.model';

export class EventCard {
  id: number;
  eventCtaButtons?: EventCtaButton[];
  title: string;
  headline: string;
  description: string;
  imageUrl?: string;
  background?: string;
  borderRadius?: string;
  order: number;
  color?: string;

  constructor(json: ClassData<EventCard>) {
    this.id = +json.id;
    if (json.eventCtaButtons)
      this.eventCtaButtons = json.eventCtaButtons.map(
        (ctaButton) => new EventCtaButton(ctaButton),
      );
    this.title = json.title;
    this.headline = json.headline;
    this.description = json.description;
    this.imageUrl = json.imageUrl;
    this.background = json.background;
    this.borderRadius = json.borderRadius;
    this.order = json.order;
    this.color = json.color;
  }
}
